import React, { Component } from "react";
import { withTranslation} from "react-i18next";
import * as _ from "lodash";
import swal from "sweetalert";
import serialize from "form-serialize";
import moment from "moment";
import { connect } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import {withRouter} from "react-router-dom";
import {withTheme} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Loader from "../loaders/loader";
import Questionnaire from "./Questionnaire";
import EvidenceCapture from "./EvidenceCapture";
import ApiServices from "../../api/api";
import OffileDb from "../../config/pouchDB";

import { db, storageRef } from "../../service/firebase";

import { gaLogEvent, gaLogScreen } from "../../helpers/analytics";
import { logError } from "../../helpers/auth";
class ServiceForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      mediaLoading: false,
      serviceDetails: [],
      lat: "",
      lng: "",
      imageURLs: [],
      audioURLs: [],
      videoURLs: [],
      offlineDate: '',
      inlineForm: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateUrl = this.updateUrl.bind(this);

  }

  componentDidMount() {
    var self = this;
    gaLogEvent("Services Questionnaire ", '', '');
    OffileDb.setDatabase()
    /**START GET LATITUBE & LONGITUDE */
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    navigator.geolocation.getCurrentPosition(
      function (position) {
        self.setState({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          zoom: 13
        });
      },
      null,
      options
    );

    /**END GET LATITUBE & LONGITUDE */
    console.log(this.props)
    if (this.props.inlineForm) {
      this.setState({ inlineForm: true })
      this.getQuestionsByServiceId(this.props.serviceObj);
    } else {
      if (!this.props.location.state) {
        this.props.history.goBack();
      } else {
        this.getQuestionsByServiceId(this.props.location.state);
      }
    }
  }


  getQuestionsByServiceId(obj) {
    console.log(obj)
    if (obj.casetype && obj.casetype == "offline") {
      this.loadOfflineCase(obj)
    } else {
      this.loadOfflineData(obj)
    }
  }

  loadOfflineCase(obj) {
    obj['questionnaire'] = obj.questionResponse
    this.setState({
      serviceDetails: [obj],
      isLoading: false,
    });
  }

  getQuestionsByServiceApidata(obj) {
    if (navigator.onLine) {
      this.setState({ isLoading: true });
      var localid = "serviceDetails" + obj.id
      var param = {
        communityId: obj.communityId,
        languageId: this.props.langId,
        serviceId: obj.id,
      };
      ApiServices.getQuestionsByServiceId(param).then((res) => {
        try {
          console.log(res.data)
          if (res && res.data && res.data.data && res.data.data.length > 0) {
            this.setState({
              serviceDetails: res.data.data,
              isLoading: false,
            });
          } else {
            this.setState({
              isLoading: false,
            });
          }
        } catch (err) {
          console.log("err::", err)
          var errorObj = {
            component: 'ServiceForm',
            method: 'getQuestionsByServiceApidata',
            error: err
          }
          logError(errorObj);
        }
      });
    }
  }

  loadOfflineData(obj) {
    var that = this
    const { t } = this.props;
    var id = "serviceDetails" + obj.id
    var formID = "serviceForm-" + obj.id
    OffileDb.getData(id).then(function (result) {
      if (result.status && result.status == 404) {
        if (!navigator.onLine) {
          swal({
            text: t("Offline data is not available"),
            icon: "success",
            button: t("ok"),
          }).then((val) => {
            that.props.history.push("/layout/services");
          });
        } else {
          that.getQuestionsByServiceApidata(obj)
        }
      } else {
        that.setState({
          serviceDetails: result.data,
          isLoading: false
        });
        //that.loadOfflineServiceForm(obj)
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    var self = this;
    const { t } = self.props;
    let { lat, lng } = self.state;
    let serviceDetails = _.cloneDeep(self.state.serviceDetails);
    let { communityuid, langId } = self.props;
    const form = event.target;
    var str = serialize(form);
    var formObj = serialize(form, { hash: true });

    let questionnaireArr = [];

    var questionarr = [];
    serviceDetails.forEach(obj => {
      questionarr = [...questionarr, ...obj.questionnaire]
    })
    questionarr.forEach((qobj, idx, qarr) => {
      var id = qobj.id;
      var value = formObj[id] != undefined ? formObj[id] : "";
      qobj.response = {
      value: Array.isArray(value) ? value : [value],
      };
      if (qarr && (idx === qarr.length - 1)) {
      qobj.responseExtension = {
      audioURLs: self.state.audioURLs, 
      comments: "",   
      imageURLs: self.state.imageURLs,     
      reviews: "",     
      summary: "",    
      videoURLs: self.state.videoURLs,    
      };  
      }   
      if (qobj && qobj.dependentQuestionsList && qobj.dependentQuestionsList.length > 0) {
      
      self.checkDependentResponsed(qobj, formObj);
      }
      questionnaireArr.push(qobj);
    });
    var now = new Date();
    let params = {
      caseStatus: {
        id: "1",
        status: "Open",
      },
      communityId: communityuid,
      languageId: langId,
      questionResponse: questionnaireArr,
      serviceId: serviceDetails[0].serviceId,
      offlineDate: self.state.offlineDate != '' && self.state.offlineDate ? self.state.offlineDate : moment(now).format('YYYY-MM-DD HH:mm:ss'),
      userDetails: {
        location: {
          coordinates: [lat, lng],
        },
        serialNumber: localStorage.getItem("deviceuuid"),
      },
      userId: JSON.parse(localStorage.getItem("obj")).userId,
    };
    console.log(serviceDetails[0], params)

    if (navigator.onLine) {
      if (Object.keys(formObj) && Object.keys(formObj).length != 0) {
        if (self.checkValidation(params)) {
          self.refs.submitbtn.setAttribute("disabled", "disabled");
          self.submitApiData(params, serviceDetails[0])
        } else {
          swal({
            text: t("Please fill all mandatory questions"),
            icon: "warning",
            button: t("ok"),
          })
        }
      } else {
        swal({
          text: t("Please select an option for reporting an issue"),
          icon: "warning",
          button: t("ok"),
        })
      }
    } else {
      self.refs.submitbtn.setAttribute("disabled", "disabled");
      self.saveOfflineServiceForm(params)
    }
  }

  checkDependentResponsed(questionobj, obj) {
    if (questionobj.dependentQuestionsList) {
      questionobj.dependentQuestionResponse = this.getDependentResponse(questionobj.dependentQuestionsList, obj)
      if (questionobj.dependentQuestionsList) {
        questionobj.dependentQuestionsList.forEach(q => {
          this.checkDependentResponsed(q, obj)
        })

      }
    }
  }

  getDependentResponse(depenArr, formObj) {
    var arr = []
    depenArr.forEach(obj => {
      var id = obj.id
      if (formObj[id] != undefined) {
        obj.response = {
          value: Array.isArray(formObj[id]) ? formObj[id] : [formObj[id]],
        };
        arr.push(obj)
      }
    })
    return arr;
  }

  checkValidation(params) {
    var flag = true;
    if (params && params.questionResponse && params.questionResponse.length > 0) {
      var questionResponse = params.questionResponse;
      for (var i = 0; i < questionResponse.length; i++) {
        if (
          questionResponse[i].isMandatory &&
          questionResponse[i].response.value[0] == ""
        ) {
          flag = false;
          break;
        } else if (!this.checkDependentValidation(questionResponse[i])) {
          flag = false;
          break;
        }
      }
    } else {
      flag = false;
    }
    return flag;
  }

  checkDependentValidation(qobj) {
    var flag = true;
    var val = qobj.response.value[0];
    if (qobj && qobj.dependentQuestionsList && qobj.dependentQuestionsList.length > 0) {
      let fobj = qobj.dependentQuestionsList.filter((o) =>
        o.selectedOption.includes(val)
      );
      if (
        fobj && 
        fobj.length > 0 &&
        fobj[0].isMandatory &&
        qobj.dependentQuestionResponse &&
        qobj.dependentQuestionResponse.length == 0
      ) {
        flag = false;
      } else {
        var questionResponse = qobj.dependentQuestionResponse;
        for (var i = 0; i < questionResponse.length; i++) {
          if (
            questionResponse[i] &&
            questionResponse[i].response.value[0] == ""
          ) {
            flag = false;
            break;
          } else if (!this.checkDependentValidation(questionResponse[i])) {
            flag = false;
            break;
          }
        }
      }
    }
    return flag;
  }


  increaseCaseCount() {
    let { communityuid } = { ...this.props };
    let channel = `${communityuid}/case/`;

    let data = {
      timestamp: Date.now(),
      communityid: communityuid,
      userid: JSON.parse(localStorage.getItem("obj")).userId,
      elType: 'case'
    };

    db.ref(channel).push(data);
  }

  submitApiData(params, serviceDetails) {
    var self = this;
    const { t } = this.props;
    const { tablist } = this.props;
    //var id = "serviceForm-" + params.serviceId
    ApiServices.addCaseForService(params).then((res) => {
      try {
        if (res.data.status == 200) {

          // additional call for realtime dashboard notification
          this.increaseCaseCount();
          if (serviceDetails.casetype != undefined && serviceDetails.casetype == "offline") {
            this.removedFromOfflineDB(serviceDetails);
          }

          swal({
            text: t("We are sorry that you are facing a TB challenge Our team will do our best to respond to the challenge you reported We will be in touch shortly"),
            icon: "success",
            button: t("ok"),
          }).then((val) => {
            if (self.state.inlineForm) {
              if (tablist.length == 1) {
                self.props.history.push("/layout");
              } else {
                self.props.handleChangeIndex(1);
              }
            } else {
              self.props.history.push("/layout/services");
            }

          });
        }
      } catch (err) {
        console.log("err::", err)
      }
    });
  }

  removedFromOfflineDB(serviceDetails) {
    OffileDb.getData('serviceOfflineReportList').then(function (result) {
      if (!result.status && result.status != 404) {
        console.log(result.data)
        if (result.data.length == 1) {
          OffileDb.removeData('serviceOfflineReportList')
        } else {
          const i = result.data.findIndex(_item => _item.offlineId == serviceDetails.offlineId);
          console.log(i)
          if (i != -1) {
            result.data.splice(i, 1);
          }
         
          var updatedata = result.data;
          OffileDb.setData('serviceOfflineReportList', updatedata)
        }
      }
    })
  }

  saveOfflineServiceForm(params, serviceDetails) {
    var self = this;
    const { t } = this.props;
    swal({
      title: t("Unstable internet connection"),
      text: t("Issue reported successfully in offline mode"),
      icon: "success",
      button: t("ok"),
    }).then((val) => {
      self.saveOfflineReportList(params, serviceDetails)
      //var id = "serviceForm-" + params.serviceId
      //OffileDb.setData(id, params)
      //self.props.history.push("/layout/services");
    });
  }

  saveOfflineReportList(params, serviceDetails) {
    var self = this;
    const { tablist } = self.props;
    params.serviceName = self.state.inlineForm ? self.props.serviceObj.name : self.props.location.state.name;
    params.offlineId = Math.floor((Math.random() * 1000) + 1);
    OffileDb.getData('serviceOfflineReportList').then(function (result) {
      if (!result.status && result.status != 404) {
        const i = result.data.findIndex(_item => _item.offlineId === serviceDetails.offlineId);
        if (i > -1) {
          result.data[i] = serviceDetails; 
        } else {
          result.data.push(params)
        }
        var updatedata = result.data;
        OffileDb.setData('serviceOfflineReportList', updatedata)
        //self.props.history.push("/layout/services");
      } else {
        OffileDb.setData('serviceOfflineReportList', [params])
        //self.props.history.push("/layout/services");
      }
      if (self.state.inlineForm) {
        if (tablist && tablist.length == 1) {
          self.props.history.push("/layout");
        } else {
          self.props.handleChangeIndex(1);
        }
      } else {
        self.props.history.push("/layout/services");
      }
    })
  }


  // loadOfflineServiceForm(obj) {
  //   var that = this;
  //   const { t } = this.props;
  //   var formID = "serviceForm-" + obj.id;
  //   var serviceDetails = this.state.serviceDetails;
  //   OffileDb.getData(formID).then(function (formData) {
  //     if (!formData.status && formData.status != 404) {
  //       var questionArr = formData.data.questionResponse
  //       serviceDetails.questionnaire = questionArr
  //       that.setState({
  //         offlineDate: formData.data.offlineDate,
  //         serviceDetails: serviceDetails,
  //         isLoading: false,
  //       });
  //       swal({
  //         text: t("Offline data synced successfully."),
  //         icon: "success",
  //         button: "Ok",
  //       }).then((val) => {
  //         console.log(val)
  //       });
  //     }
  //   })
  // }


  // getDependentResponse(depenArr, parantid, formObj) {
  //   var arr = []
  //   depenArr.forEach(obj => {
  //     var id = 'dependant-' + parantid + '-' + obj.id
  //     if (formObj[id] != undefined) {
  //       obj.response = {
  //         value: Array.isArray(formObj[id]) ? formObj[id] : [formObj[id]],
  //       };
  //       arr.push(obj)
  //     }
  //   })
  //   return arr;
  // }

  updateUrl(url, type) {
    if (type == 'image') {
      var arr = this.state.imageURLs;
      arr.push(url)
      this.setState({ imageURLs: arr })
    } else if (type == 'video') {
      var arr = this.state.videoURLs;
      arr.push(url)
      this.setState({ videoURLs: arr })
    } else if (type == 'audio') {
      var arr = this.state.audioURLs;
      arr.push(url)
      this.setState({ audioURLs: arr })
    } else if (type == 'loader') {
      this.setState({ mediaLoading: url })
    }
  }

  render() {
    const { location } = { ...this.props };
    const { t } = this.props;
    const { templateID } = this.props;

    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    if (!location.state) {
      //this.props.history.push("/layout/getknowyourrightsdetail");
    }
    return (
      <div className="gk-page getknowledge-page getknowledgeable_page">
        {
          templateID == 1 && !this.props.inlineForm && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }

        <div className="gridcontainer">
          <form id="surveyform" onSubmit={this.handleSubmit}>
            <div className={templateID == 2 ? "forumlistdivholder reportlistformdivholder" : "forumlistdivholder getinvo_inner_questiondiv"}>
              {this.state.isLoading ? (
                <Loader isLoading={this.state.isLoading} />
              ) : this.state && this.state.serviceDetails && this.state.serviceDetails.length == 0 ? (
                <p>{t('No Data Found')}</p>
              ) : (
                this.state.serviceDetails.map((sObj) => {
                  return sObj.questionnaire.map((Obj) => {
                    return <Questionnaire question={Obj} updateUrl={this.updateUrl} />;
                  })
                })
              )}
            </div>
            {this.state && this.state.serviceDetails && this.state.serviceDetails.length > 0 && (
              <>
                <div className="text-center reportsubmitbtn-divholder">
                  {templateID == 1 && <EvidenceCapture updateUrl={this.updateUrl}></EvidenceCapture>}
                  <Button
                    type="submit"
                    variant="contained"
                    style={{ background: this.props.componentbgcolor }}
                    color="primary"
                    disableElevation
                    className="reportsubmitbtn"
                    ref="submitbtn"
                  >
                    {t('submit')}
                  </Button>
                </div>
                {
                  templateID != 1 && (
                    <div className="reportform-actionbtndiv">
                      <EvidenceCapture updateUrl={this.updateUrl}></EvidenceCapture>
                    </div>
                  )
                }
              </>
            )
            }
          </form>
        </div>
      </div>
    );
  }
}

// export default withRouter(ServiceForm);

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
    componentbgcolor: storeState.componentbgcolor
  };
};

const transServiceForm = withTranslation()(ServiceForm);
const ThemeServiceForm = withTheme(transServiceForm);
// const FinalServiceForm = withStyles(ThemeServiceForm);
const routeServiceForm = withRouter(ThemeServiceForm);
export default connect(mapStateToProps, {})(routeServiceForm);
